const LiveTvAppView = () =>
  import(
    /*webpackChunkName: "LiveTvAppView"*/ "../../../views/app/LivePageApp.vue"
  );
export default {
  path: "live",
  name: "live",
  alias: [
    "live/:channelId",
  ],
  props: (route: { params: { channelId: Number } }) => ({
    channelId: route.params.channelId,
  }),
  component: LiveTvAppView,
  meta: {
    requiresAuth: false,
    isAmbiguous: true,
  },
};
